function checkTestimonials() {
    const testimonials = document.querySelectorAll('.testimonial > div')
    testimonials.forEach((testimonial) => {
        const cardBody = testimonial.querySelector('.card-body')
        if (cardBody.classList.contains('!line-clamp-none')) {
            return
        }

        if (cardBody.scrollHeight > cardBody.clientHeight) {
            testimonial.classList.add('cursor-pointer')

            testimonial.setAttribute('tabindex', '0')
        } else {
            testimonial.classList.remove('cursor-pointer')
        }
    })
}

document.addEventListener('DOMContentLoaded', checkTestimonials)
window.addEventListener('resize', checkTestimonials)

function toggleCard(e) {
    const testimonial = e.target.closest('.testimonial')
    if (testimonial) {
        const cardBody = testimonial.querySelector('.card-body')
        if (cardBody) {
            cardBody.classList.toggle('!line-clamp-none')
        }
    }
}

document.addEventListener('click', (e) => toggleCard(e))
document.addEventListener('keyup', (e) => {
    if (e.key === 'Enter') {
        toggleCard(e)
    }
})
